module.exports = __webpack_public_path__ + "static/media/2019-db.b5beffe8.png";